<template>
    <div class="verAddCon"   v-if='showModel'>
        
        <Icon class="colseButton" type="ios-close-circle" size='30' style="color:#ed4014" @click="cancel" />
            
        <Card>
            <div class="top" >
                <div class="title">{{editFormData.pageId}} -- {{editFormData.description}}</div>

                 <div class="search-div flexC" v-if='1'>
                    <div class="search-div-item flexC">
                      <div class="labelText">  {{ $t("editMesageModule.lang_zh") }}</div>
                      <Input  class="input-div"  :placeholder="$t('inputPlaceholder')"  clearable  v-model="searchObj.simpleChinese"></Input>
                    </div>

                    <div class="search-div-item flexC">
                      <div class="labelText">{{ $t("editMesageModule.lang_en") }}</div>
                      <Input  class="input-div"  :placeholder="$t('inputPlaceholder')"  clearable  v-model="searchObj.englishText"></Input>
                    </div>

                    <div class="search-div-item">
                      <Button  type="info"  @click="searchItem"  icon="ios-search"  style="margin-top: 5px;height: 44px;line-height: 44px;width: 96px;border-radius: 10px;margin-top: 5px;">{{ $t("search") }}</Button>
                    </div>
                </div>

                <div  v-if='roleType==1 && showChildrenSide'>
                     <Button  type="success" class="addButton" @click="addData(1)" style="margin-right:8px;">{{$t("productPage.mulLang.addTitle")}}</Button>
                     <Button  type="primary" class="addButton" @click="importData(1)" style="margin-right:8px;">{{$t("productPage.mulLang.importTitle")}}</Button>
                     <Button  type="info" class="addButton" :disabled="tableList.tableData.length==0" @click="savetoexcel" style="margin-right:8px;">{{$t("productPage.mulLang.exportTitle")}}</Button>
                </div>
            </div>
            <div >
                <Table style="width: 100%;margin-top: 30px;" :columns="titleName" :data="tableList.tableData"  ref="selection" @on-sort-change="sortCustom" :loading='loading'></Table>
                <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[10,15,20,50,100]" placement="top" class="pages"/>
            </div>
        </Card>

        <!-- 新增、编辑 -->
        <ModelBox :showModel.sync="addBox.showModel" :type="type"  :editFormData="addBox.editFormData" :fn="addBox.callbackFn" :roleType='roleType'></ModelBox>


        <!-- 删除 -->
        <DeleteDialog ref="deleteChild" @ievent = "ievent"  ></DeleteDialog>


        <!-- 导入 -->
        <ImportBox :showModel.sync="importBox.showModel"   :pageId="editFormData.pageId" :fn="importBox.callbackFn"></ImportBox>
    
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import * as XLSX from 'xlsx/xlsx.mjs';
import common from '@/common/common';
import DeleteDialog from '@/views/common/deleteModel.vue'; // 引入删除弹框组件
import ModelBox from './addModel.vue'; // 引入新增、编辑弹框组件
import ImportBox from './importModel.vue'; // 引入导入弹框组件
import { mapMutations,mapState } from 'vuex'
    export default {
        name: "settingModel",
        props: {
            showModel: Boolean,
            offModel: Boolean,
            fn:Function,
            fn1:Function,
            editFormData:Object,

        },
        components: {
            DeleteDialog,
            ModelBox,
            ImportBox
        },
        data() {
            return {   
                tableList:{
                    tableData:[],
                    hasSelectData:{}
                },
                loading: false,
                type:1,
                page:{//分页排序
                    total:0,//总条数
                    pageSize:15,//每页条数
                    current:1,//当前页
                    key:'createDate',
                    order:'desc'
                },
                tableList:{
                    tableDataAll:[],
                    tableData:[],
                    hasSelectData:{}
                },
                addBox:{//规格弹框组-新增
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                importBox:{//规格弹框组-新增
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                downLoadLoading:false,
                searchObj:{
                    englishText:'',
                    simpleChinese:''
                }
            }
        },
       
        computed:{
            ...mapState(['local','selectId','uInfo','showChildrenSide']),
            roleType(){
	        	let res = '2'
	        	if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	        	 res = this.$store.state.uInfo.roleType
	        	}
	        	return res
	        },
             titleName(){
                return [
                    {
                        title: 'Word_ID',
                        key: 'wordCode',
                        width: 220,
                        sortable: true,
                        tree: true
                    },
                    {
                        title: this.$t('editMesageModule.lang_zh'),
                        key: 'simpleChinese',
                        minWidth: 220
                    },
                    {
                        title: this.$t('editMesageModule.lang_en'),
                        key: 'englishText',
                        minWidth: 220
                    },
                    {
		            	title: this.$t('productPage.titleName.Operation'),
                        'title-zh-CN':'操作',
                        'title-en-US':'Operation',
                        // fixed:'right',
		            	width:140,
                        key: "Operation",
		            	render: (h, params) => {
                            let that = this
                            return h('div',{
                                style:{
                                    display:'flex',
                                    'justify-content':'center'
                                }
                            },[
                                h('Button',{
		            	              props: {
                                          type: "primary",
                                          size: 'small'
                                      },
                                      style:{
                                        'margin-right':'8px'
                                      },
		            	              on: {
		            	                  click: () => { 
                                                this.tableList.hasSelectData = params.row
                                                this.addData(2)
                                               
                                           }
		            	              }
		            	          },that.$t("edit")),
                                h('Button',{
		            	              props: {
                                          type: "error",
                                          size: 'small'
                                      },
                                      style:{
                                          'display':(this.roleType==1 && this.showChildrenSide)?"block":"none",
                                          'margin-right':'8px',
                                      },
		            	              on: {
		            	                  click: () => { 
                                              if(this.roleType==1 && this.showChildrenSide){
                                                  this.todelData(params.row)
                                              }
                                           }
		            	              }
		            	          },that.$t("delete"))
                            ])
		            	}
                    }
                    
                ]
             } 

        },
        created(){
           
        },
        watch:{
            showModel(val){
                if(val==true){
                    
                    this.getData()
                }
 
            },
        },
        methods: {
             ...mapMutations([
              'setLocal'
            ]),
            importData(){
                this.importBox.showModel = true
              
                this.importBox.callbackFn = () => {//回调处理
                    console.log(99999)
                    //重新载入
                    this.importBox.showModel = false;
                    this.getData();
                }
            },
             todelData(item) {// 删除
                this.tableList.hasSelectData = item
                this.$refs.deleteChild.showit();
            },
            ievent() {// 删除=
                this.axios.post(this.config.urlArray.delOneWordCode, {id:this.tableList.hasSelectData.id}).then((result)=>{
                    common.ajaxMsg(result.data,true,()=>{
                        this.$refs.deleteChild.recancel();
                        this.getData();
                    })
                }).catch((err)=>{
                    // common.msg('error','删除失败')
                })
            },
            async savetoexcel(){//导出
                 // 需要导出的数据
               
                const exportArr = []
                await this.getData('all')

              
                this.tableList.tableDataAll.map(item=>{
                    let obj = {
                        "wordCode": item.wordCode,
                        "simpleChinese":item.simpleChinese,
                        "traditionalChinese":item.traditionalChinese,
                        "englishText": item.englishText,
                        "frenchText":item.frenchText,
                        "germanText": item.germanText,
                        "spanishText": item.spanishText,
                        "japanText": item.japanText,
                        // "addFlag": false
                    }
                    exportArr.push(obj)
                })
              
            
                // 自定义下载的header，注意是数组中的数组哦
                const Header = [["wordCode","simpleChinese","traditionalChinese","englishText","frenchText","germanText","spanishText","japanText"]];
            
                // 将JS数据数组转换为工作表。
                const headerWs = XLSX.utils.aoa_to_sheet(Header);
                const ws = XLSX.utils.sheet_add_json(headerWs, exportArr, {skipHeader: true, origin: 'A2'});
            
                /* 新建空的工作表 */
                const wb = XLSX.utils.book_new();
            
                // 可以自定义下载之后的sheetname
                XLSX.utils.book_append_sheet(wb, ws, 'sheetName');
                
            
                /* 生成xlsx文件 */
                XLSX.writeFile(wb,`${this.editFormData.pageId}-${this.editFormData.description}.xlsx` );
            },
            addData(type) {  //添加或编辑数据
                this.addBox.showModel = true
                this.type = type

                this.addBox.editFormData.pageId = this.editFormData.pageId
                if(type == 2) {
                    this.addBox.editFormData = this.tableList.hasSelectData
                }
                this.addBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.addBox.showModel = false;
                    this.addBox.editFormData = {}
                    this.getData();
                }
            },
            searchItem() {//搜索
                this.page.current = 1
                this.page.pageSize = 15
              this.getData();
            },
            async getData(type=''){ //获取数据
                let getData = {
                    params:{
                        page:this.page.current,
                        limit:this.page.pageSize,
                        sort:this.page.key,
                        asc:this.page.order,
                        dealerId:this.selectId,
                        pageId:this.editFormData.pageId,
                        ...this.searchObj,
                    }
                }
                if(type==''){
                    this.loading = true
                }
                let paramsOther = {}
                if(type=='all'){
                    paramsOther.limit =  this.page.total
                }
               
                let  result = await  this.axios.post(this.config.urlArray.pagesLangDictionaryList,{...getData.params,...paramsOther})
                if(result){
                    let resData = result.data.data.dealersList
                    if(resData && type=='all'){
                    
                        this.tableList.tableDataAll = resData  //渲染数据,导出全部
                    }

                    common.ajaxMsg(result.data,false,()=>{
                        let resData = result.data.data.dealersList
                        //处理数组
                        if(resData && type==''){
                            this.tableList.tableData = resData  //渲染数据
                            this.page.total = result.data.data.meta.count
                            this.loading = false
                        }
                    });
                }
                
            },
            sortCustom (data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                this.getData()
            },
            changePage (nowpage) {//切换分页
                this.page.current = nowpage
                this.getData()
            },
            changeSize (nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                this.getData()
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
                this.fn1()
                this.$emit('update:offModel',true);
            }
        }
    }
</script>
<style lang="less" scoped>

.logoCon /deep/ .ivu-form-item-content{
    margin-left: 0px !important;
}
.verAddCon{
    position: relative;
    .title{
        font-size: 20px;
        padding: 4px 0 20px;
    }
    .colseButton{
        position: absolute;
        right: 0px;
        top:0px;
        cursor: pointer;
        z-index: 1;
    }
}
.info-btn {
    position: relative;
    width: 56px;
    height: 32px;
    z-index: 1;
    .input-page {
        position: absolute;
        left: 0;
        top: 0; 
        width: 100%;
        height: 32px;
        border-color: #57c5f7;
        outline: none;
        background-color: transparent;
        filter:alpha(opacity=0);
        -moz-opacity:0;
        -khtml-opacity: 0;
        opacity: 0;
        font-size: 8px;
        // display: none;
        color: #fff;
        z-index: 99;
    }
    .info-font {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 32px;
        z-index:2;
    }
}

.search-div {
  flex-wrap: wrap;
  background-color: #fff;
  padding: 10px 0px;
  background: #ffffff;
//   margin: 40px 40px 0px;
  border-radius: 14px;
  .labelText {
    line-height: 54px;
    height: 54px;
    flex-shrink: 0;
    margin-right: 10px;
  }
  .search-div-item {
    margin-right: 20px;
    span {
      margin-right: 30px;
    }
  }
  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    height: 44px;
    line-height: 44px;
  }
  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    height: 44px;
    line-height: 44px;
  }
  /deep/ .ivu-select-single .ivu-select-selection {
    height: 44px;
    width: 200px;
  }
  /deep/ .ivu-input {
    height: 44px;
    line-height: 44px;
  }
  /deep/ .ivu-input-icon {
    height: 44px;
    line-height: 44px;
  }
}


</style>
